import React from "react";
import { useParams } from "react-router-dom";

export default function BlogPostIframe() {
  const { blogId } = useParams();

  return (
    <div style={{ width: "100%", minHeight: "80vh" }}>
      <iframe
        src={`/blogs/${blogId}.html`}
        title="Blog Content"
        style={{ width: "100%", height: "100vh", border: "none" }}
      />
    </div>
  );
}
